
let final_list={
    "data":[
        {
            "headTitle1": "Dashboard",
            "headTitle2": "Get Regular Updates",
            "type": "headtitle"
        },
        {
            "path": "/dashboard/main",
            "title": "Dashboard",
            "icon": "disc",
            "type": "link"
        },
        {
            "path": "/dashboard/analytics",
            "title": "Analytics",
            "icon": "disc",
            "type": "link"
        },
        // {
        //     "path": "/dashboard/shelter",
        //     "title": "Shelter Dashboard",
        //     "icon": "disc",
        //     "type": "link"
        // },
        // {
        //     "headTitle1": "Disasters",
        //     "headTitle2": "Get Occupancy Summary",
        //     "type": "headtitle"
        // },
        // {
        //     "path": "/disasters/occupancy-summary",
        //     "title": "Occupancy Summary",
        //     "icon": "disc",
        //     "type": "link"
        // },

        // Subscribers - QuickCV
        {
            "headTitle1": "Subscription",
            "headTitle2": "Manage Your Subscribers",
            "type": "headtitle"
        },
        {
            "path": "/subscription/user/list",
            "title": "User",
            "icon": "disc",
            "type": "link"
        },
        {
            "path": "/subscription/user/analytics",
            "title": "User Analytics",
            "icon": "disc",
            "type": "link"
        },
        {
            "path": "/subscription/payment-initiated/list",
            "title": "Payment Initiated",
            "icon": "disc",
            "type": "link"
        },
        {
            "path": "/subscription/activated/list",
            "title": "Paid & Activated",
            "icon": "disc",
            "type": "link"
        },
        {
            "path": "/subscription/affiliate-referral-user/list",
            "title": "Affiliate Referral User",
            "icon": "disc",
            "type": "link"
        },
        {
            "path": "/subscription/user/route-log",
            "title": "User Route Log",
            "icon": "disc",
            "type": "link"
        },

        {
            "headTitle1": "System",
            "headTitle2": "Manage Your Payments & Packages",
            "type": "headtitle"
        },
        {
            "path": "/system/payment-log",
            "title": "Payment Log",
            "icon": "disc",
            "type": "link"
        },
            {
            "path": "/system/payment-debug",
            "title": "Payment Debug",
            "icon": "disc",
            "type": "link"
        },
        {
            "path": "/system/package",
            "title": "Package",
            "icon": "disc",
            "type": "link"
        },
        {
            "path": "/system/coin-feature",
            "title": "Coin Feature",
            "icon": "disc",
            "type": "link"
        },
        {
            "path": "/system/coupon",
            "title": "Coupon",
            "icon": "disc",
            "type": "link"
        },
        {
            "path": "/system/affiliate-referral",
            "title": "Affiliate Referral",
            "icon": "disc",
            "type": "link"
        },

        {
            "headTitle1": "Course & E-Book",
            "headTitle2": "Manage Courses and E-Books",
            "type": "headtitle"
        },
        {
            "path": "/course/partner",
            "title": "Partner",
            "icon": "disc",
            "type": "link"
        },
        {
            "path": "/course/category",
            "title": "Category",
            "icon": "disc",
            "type": "link"
        },
        {
            "path": "/course/list",
            "title": "Course",
            "icon": "disc",
            "type": "link"
        },
        {
            "path": "/course/e-book/list",
            "title": "E-Book",
            "icon": "disc",
            "type": "link"
        },
        {
            "path": "/course/voucher-redeemed/list",
            "title": "Voucher Redeemed List",
            "icon": "disc",
            "type": "link"
        },

        {
            "headTitle1": "Feedback",
            "headTitle2": "Manage User Feedbacks",
            "type": "headtitle"
        },
        {
            "path": "/feedback/list",
            "title": "Feedback",
            "icon": "disc",
            "type": "link"
        },
        {
            "headTitle1": "AI Hub",
            "headTitle2": "Centralize your AI prompts, configurations, and integrations",
            "type": "headtitle"
        },
        {
            "path": "/ai/openai-api-key",
            "title": "OpenAI API Key",
            "icon": "disc",
            "type": "link"
        },
        {
            "path": "/ai/prompt-category",
            "title": "Prompt Category",
            "icon": "disc",
            "type": "link"
        },
        {
            "path": "/ai/prompt-template",
            "title": "Prompt Template",
            "icon": "disc",
            "type": "link"
        },

        {
            "headTitle1": "Operation",
            "headTitle2": "Manage Your Data",
            "type": "headtitle"
        },
        {
            "path": "/operation/sidebar-menu",
            "title": "Sidebar Menu",
            "icon": "disc",
            "type": "link"
        },
        {
            "path": "/operation/cv-tracking-label",
            "title": "CV Tracking Label",
            "icon": "disc",
            "type": "link"
        },
        {
            "path": "/operation/digital-skill",
            "title": "Digital Skill",
            "icon": "disc",
            "type": "link"
        },
        {
            "path": "/operation/language",
            "title": "Language",
            "icon": "disc",
            "type": "link"
        },

        // {
        //     "path": "/resources/emergency-contact/list",
        //     "title": "Emergency Contacts",
        //     "icon": "disc",
        //     "type": "link"
        // },

        // {
        //     "headTitle1": "Volunteer",
        //     "headTitle2": "Register & Manage Your Volunteer",
        //     "type": "headtitle"
        // },
       
        // {
        //     "path": "/volunteer/register",
        //     "title": "Register Volunteer",
        //     "icon": "disc",
        //     "type": "link"
        // },
        // {
        //     "path": "/volunteer/list",
        //     "title": "Volunteer",
        //     "icon": "disc",
        //     "type": "link"
        // },

        // {
        //     "path": "/admin/slider",
        //     "title": "Slider",
        //     "icon": "disc",
        //     "type": "link"
        // },
       
        // {
        //     "path": "/admin/counter",
        //     "title": "Counter",
        //     "icon": "disc",
        //     "type": "link"
        // },
        // {
        //     "path": "/admin/team",
        //     "title": "Team Member",
        //     "icon": "disc",
        //     "type": "link"
        // },
        // {
        //     "path": "/admin/partner",
        //     "title": "Partners",
        //     "icon": "disc",
        //     "type": "link"
        // },

        // {
        //     "path": "/admin/application",
        //     "title": "Application",
        //     "icon": "disc",
        //     "type": "link"
        // },
 
        //Resources
        // {
        //     "headTitle1": "Resources",
        //     "headTitle2": "Manage Resources",
        //     "type": "headtitle"
        // },
        // {
        //     "title": "Press Release",
        //     "type": "sub",
        //     "icon": "disc",
        //     "active": false,
        //     "children": [
        //         {
        //             "path": "/admin/press-release",
        //             "title": "Press Release",
        //             "icon": "disc",
        //             "type": "link"
        //         },
        //         {
        //             "path": "/admin/quotes",
        //             "title": "Quotes",
        //             "icon": "disc",
        //             "type": "link"
        //         },

        //     ]
        // },
        // {
        //     "path": "/admin/news",
        //     "title": "News",
        //     "icon": "disc",
        //     "type": "link"
        // },
        // {
        //     "path": "/admin/law-policy",
        //     "title": "Law & Policy",
        //     "icon": "disc",
        //     "type": "link"
        // },
        // {
        //     "path": "/admin/audio-visuals",
        //     "title": "Audio Visuals",
        //     "icon": "disc",
        //     "type": "link"
        // },

        // {
        //     "path": "/admin/info-graphics",
        //     "title": "Info Graphics",
        //     "icon": "disc",
        //     "type": "link"
        // },
       




     
        //Get Involved
        // {
        //     "headTitle1": "Get Involved",
        //     "headTitle2": "Manage Involvements",
        //     "type": "headtitle"
        // },
        // {
        //     "path": "/admin/jobs",
        //     "title": "Employment",
        //     "icon": "disc",
        //     "type": "link"
        // },
        // {
        //     "path": "/admin/cfp",
        //     "title": "Call for Proposal",
        //     "icon": "disc",
        //     "type": "link"
        // },
        // {
        //     "path": "/admin/fellowship",
        //     "title": "Fellowship",
        //     "icon": "disc",
        //     "type": "link"
        // },
        // {
        //     "path": "/admin/qna",
        //     "title": "FAQ",
        //     "icon": "disc",
        //     "type": "link"
        // },
        // {
        //     "path": "/admin/contact",
        //     "title": "Contact",
        //     "icon": "disc",
        //     "type": "link"
        // },

        

        

        // {
        //     "headTitle1": "Campaigns & Gallery",
        //     "headTitle2": "Manage Campaigns and Gallery",
        //     "type": "headtitle"
        // },
        // {
        //     "path": "/admin/gallery",
        //     "title": "Gallery",
        //     "icon": "disc",
        //     "type": "link"
        // },

        // {
        //     "path": "/admin/campaign",
        //     "title": "Campaigns",
        //     "icon": "disc",
        //     "type": "link"
        // },
    


       


        // {
        //     "title": "Base Details",
        //     "type": "sub",
        //     "icon": "disc",
        //     "active": false,
        //     "children": [
        //         {
        //             "path": "/admin/base-detail/campaign",
        //             "title": "Campaign",
        //             "icon": "disc",
        //             "type": "link"
        //         },
        //         {
        //             "path": "/admin/base-detail/law_n_policy",
        //             "title": "Law & Policy",
        //             "icon": "disc",
        //             "type": "link"
        //         },
        //         {
        //             "path": "/admin/base-detail/news",
        //             "title": "News",
        //             "icon": "disc",
        //             "type": "link"
        //         },
        //         {
        //             "path": "/admin/base-detail/press_release",
        //             "title": "Press Release",
        //             "icon": "disc",
        //             "type": "link"
        //         },
        //         {
        //             "path": "/admin/base-detail/mission_vision",
        //             "title": "Mission & Vision",
        //             "icon": "disc",
        //             "type": "link"
        //         },
        //         {
        //             "path": "/admin/base-detail/accountibility",
        //             "title": "Accountibility",
        //             "icon": "disc",
        //             "type": "link"
        //         },
        //         {
        //             "path": "/admin/base-detail/governance",
        //             "title": "Governance",
        //             "icon": "disc",
        //             "type": "link"
        //         },
        //         {
        //             "path": "/admin/base-detail/about_article19_asia",
        //             "title": "About Article 19 Asia",
        //             "icon": "disc",
        //             "type": "link"
        //         },
               
               
              
        //     ]
        // },

    

 

      


        // {
        //     "headTitle1": "About Us",
        //     "headTitle2": "Manage about us",
        //     "type": "headtitle"
        // },
       
        // {
        //     "path": "/admin/base-detail/who_we_are",
        //     "title": "Who We Are",
        //     "icon": "disc",
        //     "type": "link"
        // },
        // {
        //     "path": "/admin/what-we-do",
        //     "title": "What We Do",
        //     "icon": "disc",
        //     "type": "link"
        // },
        // {
        //     "path": "/admin/where-we-work",
        //     "title": "Where We Work",
        //     "icon": "disc",
        //     "type": "link"
        // },


        

        // {
        //     "headTitle1": "Settings & More",
        //     "headTitle2": "Manage settings & more",
        //     "type": "headtitle"
        // },
        // {
        //     "path": "/admin/site-setting",
        //     "title": "Site Settings",
        //     "icon": "disc",
        //     "type": "link"
        // },
        // {
        //     "path": "/admin/content",
        //     "title": "Content",
        //     "icon": "disc",
        //     "type": "link"
        // },
       
       
        // {
        //     "path": "/admin/subscribers",
        //     "title": "Subscribers",
        //     "icon": "disc",
        //     "type": "link"
        // },
        // {
        //     "path": "/admin/annual-reports",
        //     "title": "Annual Reports",
        //     "icon": "disc",
        //     "type": "link"
        // },
       
    ]
}






export default final_list
